import React, { useEffect, useMemo, useRef } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Skeleton from 'react-loading-skeleton';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import './Purchase.scss';
import FormHeader from '../FormHeader/FormHeader';
import FormField from '../FormField';
import useCar from '../../utils/hooks/useCar';
import Button from '../Button';
import Recaptcha from '../Recaptcha/Recaptcha';
import bem from '../../utils/bem';
import getCardType from '../../utils/getCardType';
import {
  VISA,
  MASTER_CARD,
  AMEX,
  ENDPOINT_URL,
  SUCURSALES,
} from '../../utils/constants';
import { getUrlParameter, IsOnlyNumbers } from '../../utils/helpers';
import { useUserData } from '../../utils/hooks';

const RESERVATION_AMOUNT = 500;

const Purchase = ({ logoUrl, car, isLoading, descuentoWeb, onShowPurchase }) => {
  
  const { userData, getClientInfoRequest, gometa } = useUserData();
  const [passedCaptcha, setPassedCaptcha] = useState(false);
  const [proccessing, setProccessing] = useState(false);
  // const { coupon } = useSelector(state => ({
  //   coupon: state.personalization.coupon,
  // }));
  const { imageUrl, finalPriceWithCoupon: finalPrice } = useCar(car);
  const routerLocation = useLocation();
  const form = useRef(null);

  const callback = () => {
    setProccessing(true);
  };

  useEffect(() => {
    if (!form?.current) {
      return;
    }
    form.current.addEventListener("submit", callback, false);
    return () => {
      form.current.removeEventListener("submit", callback, false);
    };
  }, [form]);

  const getClientInfo = (dat, setField) => {
    getClientInfoRequest(dat, ({ data }) => {
      if (!data || !data?.length) {
        return;
      }
      const d = data[0];
      if (d?.guess_type === 'DIMEX/NITE') {
        setField('name_client', d.firstname);
        setField('last_name', d.lastname);
        setField('type_id', 'DIMEX');
      } else if (d?.guess_type !== 'FISICA') {
        setField('name_client', d.fullname);
        setField('last_name', 'N/A');
        setField('type_id', 'JURIDICO');
      } else {
        setField('name_client', d.firstname);
        setField('last_name', d.lastname);
        setField('type_id', 'FISICO');
      }
    });
  }

  /**
   * {
    amount,
    cardExpirationDate,
    checkout_card_card_holder,
    checkout_card_cvv,
    checkout_card_month,
    checkout_card_number,
    checkout_card_year,
    direccion,
    email,
    phone,
    last_name,
    name_client,
  }
   */

  const action = useMemo(
    () => `${ENDPOINT_URL}/api/cotizador${routerLocation.pathname}`,
    [routerLocation.pathname]
  );
  
  const errorParameter = getUrlParameter('error');
  return (
    <div className="purchase gradient gradient--full" style={{ '--color': car?.colorCode }}>
      <FormHeader
        isLoading={isLoading}
        car={car}
        logoUrl={logoUrl}
        sectionHeader="ingresá tus datos para comprar tu chuzo."
        headerText="Comprar mi vehículo"
        headerSubText="Comprá tu chuzo de manera fácil y segura…"
        bottomBorder
      />
      <div className="purchase__content classic-form">
        <div className="classic-form__form ">
        <Formik
            initialValues={{
              name_client: userData.name,
              last_name: userData.lastName,
              type_id: userData.typeId || 'FISICO',
              id_real: userData.id,
              email: userData.email,
              phone: userData.phone,
              direccion: 'N/A',
              esCompra: false,
              es_reserva: true,
              transactionType: 'reserva',
              profesion: 'N/A',
              amount: RESERVATION_AMOUNT,
              checkout_card_number: '',
              cardExpirationDate: '',
              checkout_card_month: '',
              checkout_card_year: '',
              checkout_card_cvv: '',
              checkout_card_card_holder: '',
              type: userData.typeContract,
              way_contact: userData.typeContact,
              sucursal_de_retiro: '',
              observations: '',
              politica: 'politica',
              terminos: '',
            }}
            validationSchema={Yup.object().shape({
              name_client: Yup.string().required('Requerido'),
              last_name: Yup.string().required('Requerido'),
              type_id: Yup.string().required('Requerido'),
              id_real: Yup.number().integer().test('len', 'Ingrese un formato correcto con solo números', val => {
                const hasOnlyNumbers = IsOnlyNumbers(val);
                if (!hasOnlyNumbers) {
                  return false;
                }
                return !!val && (val).toString().length <= 12 && (val).toString().length > 8; }),
              email: Yup.string().required('Requerido').email('El email es inválido'),
              phone: Yup.number().integer().test('len', 'El télefono debe contener 8 digitos y solo números', val => {
                const hasOnlyNumbers = IsOnlyNumbers(val);
                if (!hasOnlyNumbers) {
                  return false;
                }
                return !!val && (val).toString().length === 8;
              }),
              direccion: Yup.string(),
              esCompra: Yup.string().required('Requerido'),
              es_reserva: Yup.string().required('Requerido'),
              transactionType: Yup.string().required('Requerido'),
              profesion: Yup.string().required('Requerido'),
              amount: Yup.string().required(),
              checkout_card_number: Yup.string().required('Requerido'),
              cardExpirationDate: Yup.string().required('Requerido'),
              checkout_card_month: Yup.string().required('Requerido'),
              checkout_card_year: Yup.string().required('Requerido'),
              checkout_card_cvv: Yup.string().required('Requerido'),
              checkout_card_card_holder: Yup.string().required('Requerido'),
              type: Yup.string().required('Requerido'),
              way_contact: Yup.string().required('Requerido'),
              sucursal_de_retiro: '',
              observations: Yup.string(),
              politica: Yup.string().required('Requerido'),
              // terminos: Yup.string().required('Requerido'),
            })}
            onSubmit={values => {
              onShowPurchase(values);
            }}
          >
            {formik => {
              const cardType = getCardType(formik.values.checkout_card_number);
              return (
                <form onSubmit={formik.handleSubmit} ref={r => form.current = r}> 
                  <div className="classic-form__header">
                    <div className="classic-form__header-info">
                      <h4 className="classic-form__mobile-header classic-form__desktop-header desktop ">
                      INGRESÁ TUS DATOS PARA COMPRAR TU CHUZO.
                      </h4>
                      {!!errorParameter && (
                        <p className="form-error">
                          {errorParameter}
                        </p>
                      )}
                      <h3 className="classic-form__subheader">Datos personales</h3>
                      <div className="form-field">
                        <label className="form-field__label">Para agilizar el proceso <strong>ingresá</strong> tu número de identificación.</label>
                      </div>
                    </div>
                    <div className="classic-form__header-img purchase__image">
                      {!imageUrl ? (
                        <Skeleton circle={true} height={200} width={200} />
                      ) : (
                        <img src={imageUrl} alt="Vehiculo" />
                      )}
                    </div>
                  </div>
                  <br/>
                  <div className="classic-form__row">
                    <div className="classic-form__field">
                      <FormField
                        label="Número de Identificación"
                        id="id_real"
                        name="id_real"
                        type="number"
                        placeholder="000000000"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.id_real}
                        touched={formik.touched.id_real}
                        error={formik.errors.id_real}
                        required
                        pattern="[0-9\]+"
                      />
                      {!gometa?.isLoading && <span className="waiting-message waiting-message--search">
                        <Button type="red" button="button" onClick={(e) => {
                          e.preventDefault();
                          if (formik?.errors?.id_real) {
                            return;
                          }
                          getClientInfo(formik?.values?.id_real, formik.setFieldValue);
                        }}>  
                          Buscar
                        </Button>
                      </span>}
                      {gometa?.isLoading && <span className="waiting-message"> Espera unos segundos y verifica tu información.</span>}
                    </div>
                  </div>
                  <div className="classic-form__row">
                    <div className="classic-form__field">
                      <FormField
                        label="Nombre"
                        id="name_client"
                        name="name_client"
                        type="text"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.name_client}
                        touched={formik.touched.name_client}
                        error={formik.errors.name_client}
                        required
                      />
                    </div>
                    <div className="classic-form__field">
                      <FormField
                        label="Apellidos"
                        id="last_name"
                        name="last_name"
                        type="text"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.last_name}
                        touched={formik.touched.last_name}
                        error={formik.errors.last_name}
                        required
                      />
                    </div>
                    <div className="classic-form__field">
                      <FormField
                        label="Correo electrónico"
                        id="email"
                        name="email"
                        type="text"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.email}
                        touched={formik.touched.email}
                        error={formik.errors.email}
                        required
                      />
                    </div>
                    <div className="classic-form__field">
                      <FormField
                        label="Número de teléfono"
                        id="phone"
                        name="phone"
                        type="number"
                        placeholder="88888888"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.phone}
                        touched={formik.touched.phone}
                        error={formik.errors.phone}
                        required
                      />
                    </div>
                  </div>
                  <div className="classic-form__row">
                    <div className="classic-form__field" style={{zIndex: 6}}>
                      <FormField
                        label="Tipo de Identificación"
                        id="type_id"
                        name="type_id"
                        type="select"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.type_id}
                        touched={formik.touched.type_id}
                        error={formik.errors.type_id}
                        required
                        options={[
                          { value: 'FISICO', label: 'Físico' },
                          { value: 'JURIDICO', label: 'Jurídico' },
                          { value: 'DIMEX', label: 'DIMEX' },
                          {
                            value: 'CUERPO DIPLOMATICO',
                            label: 'Cuerpo Diplomático',
                          },
                        ]}
                      />
                    </div>
                    <div className="classic-form__field" style={{display: 'none' }}>
                      <FormField
                        label="Dirección"
                        id="direccion"
                        name="direccion"
                        type="text"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.direccion}
                        touched={formik.touched.direccion}
                        error={formik.errors.direccion}
                      />
                    </div>
                    <div className="classic-form__field" style={{display: 'none' }}>
                      <FormField
                        label="Profesión"
                        id="profesion"
                        name="profesion"
                        type="text"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.profesion}
                        touched={formik.touched.profesion}
                        error={formik.errors.profesion}
                        required
                      />
                    </div>
                    <div className="classic-form__field" style={{zIndex: 2}}>
                      <FormField
                        label="Sucursal de retiro"
                        id="sucursal_de_retiro"
                        name="sucursal_de_retiro"
                        type="select"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.sucursal_de_retiro}
                        touched={formik.touched.sucursal_de_retiro}
                        error={formik.errors.sucursal_de_retiro}
                        required
                        options={SUCURSALES}
                      />
                    </div>
                  </div>
                  <h3 className="classic-form__subheader">Datos de pago</h3>
                  <div className="classic-form__row">
                    <div className="classic-form__field classic-form__field--flex-auto">
                      <input type="hidden" 
                        name="tieneCupon"
                        value={car.descuentoAplicado ? "1" : "0"}
                      />
                      <input type="hidden" 
                        name="montoCupon"
                        value={car.descuentoAplicado ? car.descuentoGerencia: 0}
                      />
                      {car.descuentoWebAplicado &&
                        <input type="hidden" 
                          name="descuentoWebMonto"
                          value={descuentoWeb.monto}
                        />
                      }
                      <input
                        type="hidden"
                        value={formik.values.esCompra}
                        name="esCompra"
                        readOnly
                      />
                      <input
                        type="hidden"
                        value={formik.values.es_reserva}
                        name="es_reserva"
                        readOnly
                      />
                      <input
                        type="hidden"
                        name="checkout_card_month"
                        value={formik.values.checkout_card_month}
                        readOnly
                      />
                      <input
                        type="hidden"
                        name="checkout_card_year"
                        value={formik.values.checkout_card_year}
                        readOnly
                      />
                      <input
                        type="hidden"
                        name="way_contact"
                        value={formik.values.way_contact}
                        readOnly
                      />
                      <input
                        type="hidden"
                        name="type"
                        value={formik.values.type}
                        readOnly
                      />


                      <FormField
                        orientation="horizontal"
                        label="Seleccionar trámite"
                        id="transactionType"
                        name="transactionType"
                        type="radio"
                        onChange={event => {
                          if (event.target.value === 'compra') {
                            formik.setFieldValue('amount', finalPrice);
                            formik.setFieldValue('esCompra', true);
                            formik.setFieldValue('es_reserva', false);
                          } else {
                            formik.setFieldValue('amount', RESERVATION_AMOUNT);
                            formik.setFieldValue('esCompra', false);
                            formik.setFieldValue('es_reserva', true);
                          }
                          formik.handleChange(event);
                        }}
                        value={formik.values.transactionType}
                        touched={formik.touched.transactionType}
                        error={formik.errors.transactionType}
                        required
                        options={[
                          { value: 'compra', label: 'Compra' },
                          { value: 'reserva', label: 'Reserva' },
                        ]}
                      />
                    </div>
                    <div className="classic-form__field">
                      <FormField
                        inlineTitle
                        label={`Monto de ${formik.values.transactionType}`}
                        id="amount"
                        name="amount"
                        type="currency"
                        placeholder="$"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.amount}
                        touched={formik.touched.amount}
                        error={formik.errors.amount}
                        required
                        disabled
                      />
                    </div>
                  </div>
                  <h3 className="classic-form__subheader">
                    Información de la tarjeta
                  </h3>
                  <div className={'classic-form__row--hide '+ bem('classic-form__row', {
                    show: userData.id || gometa.isReady || true
                  })}>
                    <div className="classic-form__field">
                      <FormField
                        label="Nombre del titular de la tarjeta"
                        id="checkout_card_card_holder"
                        name="checkout_card_card_holder"
                        type="text"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.checkout_card_card_holder}
                        touched={formik.touched.checkout_card_card_holder}
                        error={formik.errors.checkout_card_card_holder}
                        required
                      />
                    </div>
                    <div className="classic-form__field">
                      <FormField
                        label="Número de tarjeta"
                        id="checkout_card_number"
                        name="checkout_card_number"
                        type="text"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.checkout_card_number}
                        touched={formik.touched.checkout_card_number}
                        error={formik.errors.checkout_card_number}
                        required
                      />
                    </div>
                    <div className="classic-form__field classic-form__field--half classic-form__field--credit-card">
                      <div className="classic-form__column">
                        <FormField
                          label="Fecha de caducidad"
                          id="cardExpirationDate"
                          name="cardExpirationDate"
                          type="masked"
                          onChange={event => {
                            const { value } = event.target || '';

                            const [month, year] = value
                              .replace(/A/gi, '')
                              .replace(/M/gi, '')
                              .split('/');
                            formik.setFieldValue('checkout_card_month', month);
                            formik.setFieldValue('checkout_card_year', year);
                            formik.handleChange(event);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.cardExpirationDate}
                          touched={formik.touched.cardExpirationDate}
                          error={formik.errors.cardExpirationDate}
                          required
                          format="##/##"
                          mask={['M', 'M', 'A', 'A']}
                          placeholder="MM/AA"
                        />
                        <FormField
                          label="CVV"
                          id="checkout_card_cvv"
                          name="checkout_card_cvv"
                          type="text"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.checkout_card_cvv}
                          touched={formik.touched.checkout_card_cvv}
                          error={formik.errors.checkout_card_cvv}
                          required
                        />
                        <div className="classic-form__field flex-end" style={{display: 'flex', alignItems: 'flex-end'}}>
                          <div
                            className={bem('classic-form__card-type', {
                              visa: cardType === VISA,
                              'master-card': cardType === MASTER_CARD,
                              amex: cardType === AMEX,
                            })}
                          ></div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="classic-form__field flex-end">
                      <div
                        className={bem('classic-form__card-type', {
                          visa: cardType === VISA,
                          'master-card': cardType === MASTER_CARD,
                          amex: cardType === AMEX,
                        })}
                      ></div>
                    </div> */}
                  </div>
                  <h3 className="classic-form__subheader">
                    Detalles de tu reserva
                  </h3>
                  <div className="classic-form__row" style={{position: 'relative'}}>
                    <div className="classic-form__field">
                      <FormField
                        label="Tipo de contrato"
                        id="type"
                        name="type"
                        type="radio"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.type}
                        touched={formik.touched.type}
                        error={formik.errors.type}
                        required
                        options={[
                          { value: 'CONTADO', label: 'Contado' },
                          { value: 'CREDITO LARGO PLAZO', label: 'Crédito largo plazo' },
                        ]}
                      />
                    </div>
                    <div className="classic-form__field">
                      <FormField
                        label="Quiero que me contacten por"
                        id="way_contact"
                        name="way_contact"
                        type="radio"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.way_contact}
                        touched={formik.touched.way_contact}
                        error={formik.errors.way_contact}
                        required
                        options={[
                          { value: 'whatsapp', label: 'Whatsapp' },
                          { value: 'email', label: 'Correo electrónico' },
                          { value: 'call', label: 'Llamada' },
                        ]}
                      />
                      {/* <p className="classic-form__mandatory-legend">
                          * Campos obligatorios
                        </p> */}
                    </div>
                    <div className="classic-form__field classic-form__field--half">
                      <FormField
                        label="Escribe alguna observación o detalle importante de tu reserva"
                        id="observations"
                        name="observations"
                        type="textarea"
                        placeholder="Escribe un comentario…"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.observations}
                        touched={formik.touched.observations}
                        error={formik.errors.observations}
                      />
                    </div>
                    <p className="classic-form__mandatory-legend">
                      * Campos obligatorios
                    </p>
                  </div>
                  <div className="classic-form__row">
                      <FormField
                        style={{ margin: "1.9rem 0" }}
                        url="/wp-content/themes/veinsa/files/politicas_de_privacidad.pdf"
                        label=""
                        id="politica"
                        name="politica"
                        type="radio"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.politica}
                        touched={formik.touched.politica}
                        error={formik.errors.politica}
                        options={[
                          {
                            component: (
                              <>
                                <div className="classic-form__field--anchor">
                                *<a target="_blank" href="/wp-content/themes/veinsa/files/politicas_de_privacidad.pdf">ACEPTO POLÍTICAS DE PRIVACIDAD</a> Y <a target="_blank" href="/wp-content/themes/veinsa/files/terminos_condiciones_veinsamotors.pdf">TÉRMINOS Y CONDICIONES</a>
                                </div>
                              </>
                            ),
                            value: 'politica',
                            label: 'Acepto Política de privacidad',
                          },
                        ]}
                      />
                      <div className="classic-form__row classic-form__row--send">
                        <Recaptcha
                          onChange={value => {
                            if (value) {
                              setPassedCaptcha(true);
                            }
                          }}
                        />
                        <Button submit disabled={!passedCaptcha || !formik.isValid || proccessing} type="red">
                          {proccessing ? 'Procesando':'Enviar solicitud'}
                        </Button>
                        
                      </div>
                    </div>
                </form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default Purchase;
